import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { jobData } from "../components/jobData";
import "../assets/css/JobsDetailsPage.css";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";

export default function JobsDetails() {
  const { jobId } = useParams();
  const job = jobData.find(j => j.id === parseInt(jobId));

  // ✅ Added States (No layout change)
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [selectedJob, setSelectedJob] = useState(job?.name || "");
  const [resume, setResume] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  if (!job) return <p>Job not found</p>;

  // ✅ Submit Function
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");

    if (!resume) {
      setErrorMessage("Please upload your resume");
      return;
    }

    const formData = new FormData();
    formData.append("fullName", fullName);
    formData.append("phone", phone);
    formData.append("email", email);
    formData.append("message", message);
    formData.append("jobRole", selectedJob);
    formData.append("resume", resume);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/job-application`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage("Application submitted successfully ✅");
        setFullName("");
        setPhone("");
        setEmail("");
        setMessage("");
        setResume(null);
      } else {
        setErrorMessage(data.message || "Failed to submit application");
      }
    } catch (error) {
      setErrorMessage("Server error. Try again later.");
    }
  };

  return (
    <>
      <BreadcrumbSection
        title="Redefining Healthcare with Precision and Passion."
        breadcrumbItems={[
          { label: "Home", to: "/" },
          { label: "Jobs", to: "/jobs" },
        ]}
        backgroundImage={BredcrumpImage}
      />

      <div className="jobdetails-container">

        {/* Title Section */}
        <div className="job-header">
          <p className="time-badge">{job.postedTime}</p>
          <h2 className="job-title">{job.name}</h2>
          <p className="company-name">{job.company}</p>
          <div className="job-header-info">
            <span>🏢 {job.category}</span>
            <span>🕒 {job.type}</span>
            <span>📍 {job.location.join(", ")}</span>
          </div>
        </div>

        <div className="job-body-wrapper">

          {/* LEFT MAIN CONTENT */}
          <div className="job-left">

            <h3 className="section-title">Job Description</h3>
            {job.description.map((desc, i) => (
              <p key={i} className="job-desc">{desc}</p>
            ))}

            <h3 className="section-title">Key Responsibilities</h3>
            <ul className="custom-list">
              {job.responsibilities.map((res, i) => (
                <li key={i}>{res}</li>
              ))}
            </ul>

            <h3 className="section-title">Requirements</h3>
            <ul className="custom-list">
              {job.requirements?.map((req, i) => (
                <li key={i}>{req}</li>
              ))}
            </ul>

            <h3 className="section-title">Professional Skills</h3>
            <ul className="custom-list">
              {job.skills.map((skill, i) => (
                <li key={i}>{skill}</li>
              ))}
            </ul>

            {/* Contact Form */}
            <div className="contact-box" id="applyForm">
              <h3>Send Us Message</h3>

              {/* ✅ Success / Error Messages */}
              {successMessage && (
                <p style={{ color: "green", marginBottom: "10px" }}>
                  {successMessage}
                </p>
              )}
              {errorMessage && (
                <p style={{ color: "red", marginBottom: "10px" }}>
                  {errorMessage}
                </p>
              )}

              {/* ✅ Added form wrapper only */}
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <input
                    type="text"
                    placeholder="Full name"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    required
                  />
                  <input
                    type="text"
                    placeholder="Phone Number"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                </div>

                <input
                  type="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />

                <textarea
                  placeholder="Your Message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>

                <select
                  className="job-select"
                  value={selectedJob}
                  onChange={(e) => setSelectedJob(e.target.value)}
                >
                  {jobData.map((j) => (
                    <option key={j.id} value={j.name}>
                      {j.name}
                    </option>
                  ))}
                </select>

                <div className="form-row">
                  <label htmlFor="resumeUpload">Upload Resume:</label>
                  <input
                    type="file"
                    id="resumeUpload"
                    accept=".pdf,.doc,.docx"
                    onChange={(e) => setResume(e.target.files[0])}
                    required
                  />
                </div>

                <button type="submit" className="send-btn">
                  Send Message
                </button>
              </form>
            </div>
          </div>

          {/* RIGHT SIDEBAR */}
          <div className="job-right">
            <button
              className="apply-btn"
              onClick={() => {
                const form = document.getElementById("applyForm");
                if (form) {
                  form.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              Apply Job
            </button>

            <div className="overview-box">
              <h4>Job Overview</h4>
              <div className="overview-item"><span>Job Title</span><p>{job.name}</p></div>
              <div className="overview-item"><span>Job Type</span><p>{job.type}</p></div>
              <div className="overview-item"><span>Category</span><p>{job.category}</p></div>
              <div className="overview-item"><span>Experience</span><p>{job.experience}</p></div>
              <div className="overview-item"><span>Degree</span><p>{job.degree}</p></div>
              <div className="overview-item"><span>Location</span><p>{job.location.join(", ")}</p></div>
            </div>

            <h4 className="tag-title">Tags:</h4>
            <div className="tags-list">
              {job.tags.map((tag, i) => <span key={i}>{tag}</span>)}
            </div>
          </div>

        </div>
      </div>
    </>
  );
}
